// extracted by mini-css-extract-plugin
export default {"root":"LR9iCwph","logoLine":"_2QZAI5Ee","title":"qG5XMaSm","subtitle":"ZC+xET9D","logo":"cbY4-wIe"};